import { useQuery } from '@tanstack/react-query'

import { fetchVersionInfo } from '#util/checkVersion'

export type { VersionInfo } from '#util/checkVersion'

export const useVersionInfo = () => {
  return useQuery({
    queryKey: ['versionInfo'],
    queryFn: fetchVersionInfo,
    staleTime: Infinity,
  })
}
